"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.channelBannerEnabled = channelBannerEnabled;
function channelBannerEnabled(banner) {
    if (!banner) {
        return false;
    }
    return Boolean(banner.enabled) && Boolean(banner.text) && Boolean(banner.background_color);
}
